import {Heading} from "components/styled"
import React, {Component} from "react";
import styled from "styled-components"
import {getMunData} from "../../utils"
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {getMun} from "../../utils";

class Downloads extends Component {
    constructor(props) {
        super(props);
        this.state = {
            downloadRootPath: "", ocdsFiles: undefined
        }
    }

    componentDidMount() {
        const REACT_APP_ADMIN_URL = process.env.REACT_APP_ADMIN_URL + '/ocds/';
        this.setState({
            ...this.state, downloadRootPath: REACT_APP_ADMIN_URL, ocdsFiles: getMunData().ocdsFiles,
        })
    }

    render() {
        const fiscalYears = this.props.fiscalYears
        const munName = getMun();

        const handleFileName = (fiscalYear, fileType) => (`${munName}-${fiscalYear}.${fileType}`)

        return (<Content>
            <div className={'download-group'}>
                <Heading.h1 uppercase>Excel Downloads</Heading.h1>
                <ul className="download-list">
                    {fiscalYears.map((year, index) => {
                        return (<li key={index}>
                            <a href={`${this.state.downloadRootPath}sheets/${handleFileName(year.name, 'xlsx')}`}
                               className={'download-link'}>{handleFileName(year.name, 'xlsx')}</a>
                        </li>)
                    })}
                </ul>
            </div>
            <div className={'download-group'}>
                <Heading.h1 uppercase>JSON Downloads</Heading.h1>
                <ul className="download-list">
                    {fiscalYears.map((year, index) => {
                        return (<li key={index}>
                            <a href={`${this.state.downloadRootPath}json/${handleFileName(year.name, 'json')}`}
                               className={'download-link'} target={'_blank'}>{handleFileName(year.name, 'json')}
                            </a>
                        </li>)
                    })}
                </ul>
            </div>
            {!fiscalYears.length && <div><p>No OCDS Files generated for this municipality.</p></div>}
        </Content>)
    }
}


const mapStateToProps = state => ({
    fiscalYears: state.staticData.fiscalYears,
});


export default connect(mapStateToProps)(withRouter(Downloads));


const Content = styled.div`
  @media screen and (min-width: 768px) {
    display: flex;
  }

  .download-group {
    @media screen and (min-width: 768px) {
      width: 50%;
    }

    > h1 {
      margin-bottom: 12px;
      font-weight: 600;
    }

    .download-list {
      li {
        &:not(:last-child) {
          margin-bottom: 8px;
        }
        .download-link {
          color: var(--color-link);
          font-size: 16px;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }

    &:not(:last-child) {
      margin-bottom: 24px;
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/downloads/downloads.js